import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BugReportService } from "../services/bug-report/bug-report.service";

@Injectable()
export class BugReportInterceptor implements HttpInterceptor {
  constructor(private bugReportService: BugReportService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Only log errors (4xx and 5xx status codes)
        if (error.status >= 400) {
          this.bugReportService.addNetworkError(error, req.body, req.method);
        }

        return throwError(() => error);
      })
    );
  }
}
